import { getColumns, getKeys, getRows } from '../../../components/form/GenderInput';
import type { Page } from '../../types';
import { type GradeValue, gradeValueToLabel } from '../../utils/csc';

const rows = getRows().map((row) => ({
  name: row,
  label: gradeValueToLabel(row as GradeValue),
}));
const columns = getColumns();

const gender: Page[] = [
  {
    pageType: 'question',
    title: 'Gender',
    name: 'fair-and-open-gender',
    hidePageTitle: true,
    description:
      'Please provide a breakdown according to gender for the individuals recruited through fair and open competition',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'inset',
        title: '',
        insetContent:
          'You reported <strong>${1}</strong> people recruited through fair and open competition.<br><br>' +
          'Please provide a grade breakdown of these people by their grade and gender.<br><br>',
        insetVariables: {
          1: {
            type: 'previousAnswer',
            key: 'headline-fair-and-open',
          },
        },
        name: 'external-recruit-gender-inset',
        detailsContent: 'Gender inset',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'genderInput',
        title: 'Breakdown',
        name: 'gender-input-details',
        detailsHeading: 'More information',
        detailsContent: 'If the grade does not align directly you can use the equivalent',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-fair-and-open',
          fieldsEqual: rows.map((row) => ({
            fields: columns.map((column) => `${row.name}${column}`),
            answer: 'fair-and-open-grade-column',
            answerValue: row.name,
            errorPrefix: `The total of ${row.label} exceptions must equal`,
          })),
        },
      },
    ],
  },
];

export default gender;
